var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-cont module-app"},[_c('header',{staticClass:"home-header"},[_c('img',{attrs:{"src":"//cdn.hhdd.com/frontend/as/i/748413ef-3bfb-5b5b-b024-33997cd70378.png","alt":"header_banner"}}),_vm._v(" "),_c('i',{staticClass:"btn",on:{"click":_vm.downApp}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc232558","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/QRAndBg.vue
// module id = B5rl
// module chunks = 0 1